var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zidingyi"},[_c('span',[_c('span',{staticClass:"mark"},[(_vm.isTrue)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(_vm._s(_vm.title))]),_c('input',{attrs:{"type":_vm.type},on:{"input":function($event){return _vm.updateVal($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }